import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "layout" }, [
    _c("div", { staticClass: "layout__wrapper overflow-ellipsis" }, [
      _c("input", {
        attrs: { name: "selected", type: "radio" },
        domProps: { value: _vm.params.data._id, checked: _vm.isCurrentLayout },
      }),
      _vm._v(" "),
      _c(
        "span",
        {
          class: [
            "layout__name",
            { "layout__name--current": _vm.isCurrentLayout },
          ],
        },
        [_vm._v("\n      " + _vm._s(_vm.params.data.name) + "\n    ")]
      ),
    ]),
    _vm._v(" "),
    _vm.isDeleteVisible
      ? _c(
          "div",
          [
            _c(
              VIcon,
              {
                attrs: { small: "", color: "primary" },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.params.onDeleteLayout(_vm.params.data)
                  },
                },
              },
              [_vm._v("\n      mdi-delete-outline\n    ")]
            ),
          ],
          1
        )
      : _vm.isCurrentLayout && _vm.hasDeletePermission
      ? _c(
          "div",
          [
            _c(
              VTooltip,
              {
                attrs: { top: "" },
                scopedSlots: _vm._u([
                  {
                    key: "activator",
                    fn: function ({ on }) {
                      return [
                        _c(
                          VIcon,
                          _vm._g(
                            {
                              staticClass: "delete-disabled",
                              attrs: { small: "", color: "grey" },
                            },
                            on
                          ),
                          [_vm._v(" mdi-delete-outline ")]
                        ),
                      ]
                    },
                  },
                ]),
              },
              [
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("grid.layouts.messages.cannotDeleteActive"))
                  ),
                ]),
              ]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }